import React, { useEffect } from 'react';

export default function ElchmE() {
  useEffect(() => {
    window.location.href = 'https://ElchmE.com';
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-light text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
          Traveling to the Alchemy...
        </h1>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500 mx-auto"></div>
      </div>
    </div>
  );
}
